<template lang="pug">
#visibilidade-camada
    el-checkbox(v-model='selecionado', @change='onChange') Visibilidade da área plantada
</template>

<script>
export default {
    name: 'VisibilidadeCamadaAreaPlantada',
    props: {
        onChange: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            selecionado: true
        };
    }
};
</script>

<style lang="scss">
#visibilidade-camada {
    position: absolute;
    display: flex;
    top: 15px;
    left: 15px;
    bottom: 15px;
    height: 24px;
    padding: 2px 4px;
    z-index: 1020;
    background-color: var(--white);
    @include border-radius(4px);

    .el-checkbox__label {
        color: #424242;
        font-weight: 400;
        font-size: 13px;
    }
}
</style>
